<template>
  <header class="c_cs_header">
    <div class="c_wrapper">
      <div class="c_cs_header__leading_text">
        <h4 class="c_text--graphik_semibold" v-if="eyebrow">{{ eyebrow }}</h4>
        <h1 class="c_2022--h1_schnyder" v-if="title">{{ title }}</h1>
        <p class="c_2022--lead c_lead_paragraph" v-if="!useQuoteAsSubtitle && leadParagraph">{{ leadParagraph }}</p>
        <div
          class="c_quote_wrapper"
          v-else-if="useQuoteAsSubtitle && quote"
        >
          <p class="c_quote" v-if="quote">"{{ quote }}"</p>
          <cite
            aria-label="Lead paragraph author"
            v-if="quoteAuthor"
            class="c_quote_author c_text--graphik_regular c_2022--body"
            v-html="quoteAuthor"
          ></cite
          ><span v-if="quoteAuthorTitle">, </span
          ><cite
            aria-label="Lead paragraph author title"
            v-if="quoteAuthorTitle"
            v-html="quoteAuthorTitle"
            class="c_quote_author-title c_2022--body"
          ></cite
          ><span v-if="quoteAuthorWorkplace">, </span
          ><cite
            aria-label="Lead paragraph author workplace"
            v-if="quoteAuthorWorkplace"
            v-html="quoteAuthorWorkplace"
            class="c_quote_author-workplace c_2022--body"
          ></cite>
        </div>
      </div>
      <div
        class="c_cs_header__details"
        v-if="detailsTable"
        :class="{ 'c_cs_header__details--multi': detailsTable.length > 0 }"
      >
        <div class="c_chart__item" v-for="(column, index) in detailsTable" :key="index">
          <h4 class="c_text--graphik_medium" v-if="column.detailTitle">{{ column.detailTitle }}</h4>
          <div class="c_text--graphik_regular" v-if="column.detailDescription" v-html="column.detailDescription"></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    eyebrow: String,
    title: String,
    useQuoteAsSubtitle: Boolean,
    leadParagraph: String,
    quote: String,
    quoteAuthor: String,
    quoteAuthorTitle: String,
    quoteAuthorWorkplace: String,
    detailsTable: Array,
  },
};
</script>

<style lang="scss">
.c_cs_header {
  $self: &;

  background-color: $color_black;
  color: $color_white;
  padding-top: px_to_rem(64);
  padding-bottom: px_to_rem(64);
  @media (max-width: 700px) {
    padding-top: px_to_rem(48);
    padding-bottom: px_to_rem(48);
  }
  h4 {
    @include font('graphik_medium');
    color: $color_yellow;
  }
  h1 {
    @include font('schnyder_wide_l_light');
    @include mq(1025px) {
      padding: px_to_rem(8) 0 px_to_rem(32);
    }
    padding: px_to_rem(16) 0 px_to_rem(32);
  }
  .c_2022--lead {
    font-weight: bold;
    font-style: normal;
    max-width: 800px;
    padding-top: 1.5rem 0;

    &.c_lead_paragraph{
      @include font('graphik_regular');
      margin-bottom: px_to_rem(24);
      word-wrap: break-word;
      width: 100%
    }
  }
  .c_quote_wrapper {
    margin-bottom: px_to_rem(24);
    .c_quote{
      @include font('schnyder_wide_m_light');
      max-width: 800px;
      font-size: px_to_rem(24);
      line-height: px_to_rem(32);
      margin-bottom: px_to_rem(24);
    }
    .c_quote_author {
      @include font('graphik_semibold');
    }
    .c_quote_author-title {
      @include font('graphik_regular_italic');
    }
    .c_quote_author-workplace {
      @include font('graphik_semibold_italic');
    }
  }
  @at-root #{&}__leading_text {
    display: flex;
    flex-direction: column;
    text-align: center;
    place-items: center;

    @media (max-width: 1025px) {
      place-items: start;
      text-align: left;

      p{
        font-size: 1.35rem;
        line-height: 1.85rem;
      }
    }
  }
  @at-root #{&}__details {
    text-align: center;
    max-width: px_to_rem(1150);
    @include mq(1025px) {
      display: flex;
      justify-content: center;
      margin-top: px_to_rem(32);
    }
    @media (max-width: 1025px) {
      text-align: left;
      justify-items: start;
    }
    ul {
      padding-left: px_to_rem(20);
      li {
        list-style-type: disc;
      }
    }
    ol {
      padding-left: px_to_rem(20);
      li {
        list-style-type: decimal;
      }
    }
    a,
    a:visited {
      color: $color_yellow;
      transition: all .3s;
      text-underline-offset: 2px;

      &:hover {
        text-underline-offset: 4px;
      }
    }
    @at-root #{&}--multi {
      & > div {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        gap: .5rem;
        padding: px_to_rem(24) px_to_rem(0) px_to_rem(24);

        @include mq(1025px) {
          padding: px_to_rem(16) px_to_rem(16) px_to_rem(8);
          align-items: center;
          text-align: center;

          &:not(:last-child) {
            border-right: px_to_rem(1) solid #393939;     
          }
        }
      }

      .c_chart__item {
        width: 100%;
        justify-content: flex-start;
        p {
          margin-bottom: 4px;
        }
      }
      @media (min-width: 1024px) {
        .c_chart__item {
          * {
            max-width: 300px;
          }
        }
        .c_2022--body {
          p {
            margin-top: px_to_rem(8);
          }
        }
      }
      @media (max-width: 1023px) {
        & > div {
          &:not(:last-child) {
            border-bottom: px_to_rem(1) solid #393939;
          }
        }
      }
    }
  }
}
.margin-none{
  margin: 0
}
</style>
